import { get } from 'lodash';

const module = angular.module('whyline.controllers.macro-login', [
  'whyline.services.auth',
  'whyline.services.errors',
]);

const MacroLoginController = (
  AuthService,
  $timeout,
  $stateParams,
  $scope,
  SAFE_STATES,
  ErrorService,
  $state,
  dialog,
  $translate,
) => {
  $scope.message = '';
  $timeout(() => {
    const token = $stateParams.token;
    AuthService.MacroLogin(token)
      .then(() => {
        $state.go(SAFE_STATES.organizationsList);
      })
      .catch((err) => {
        const errorCode = get(err, 'data.message', null);
        err.context = get(err, 'data.context', {});

        let hideError = false;
        if (err.status === 409 && errorCode === 'user.should-close-sessions') {
          hideError = true;
          dialog.confirm($translate.instant('user.should-close-sessions')).then(() => {
            AuthService.CloseSessionsByTokenAndSignIn(token).then(() => {
              $state.go(SAFE_STATES.organizationsList);
            });
          });
        } else if (err.status === 404 && errorCode === 'macro-login.user-not-found') {
          const userExternalId = get(err, 'context.info.userExternalId', '');
          const msj = $translate
            .instant('macro-login.user-{user}-not-found')
            .replace('{user}', userExternalId);
          $scope.message = msj;
        }

        if (!hideError) {
          ErrorService.handler(err);
        }
      });
  });
};

module.exports = module.controller('MacroLoginController', MacroLoginController);
